import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NewsFacade } from '../facade/news.facade';

export function newsCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const newsFacade = inject(NewsFacade);
        newsFacade.clear();

        return true;
    };
}
